// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__L1im2","profile_container":"profile_profile_container__UWmCQ","container":"profile_container__+5iY2","description":"profile_description__K8JtB"};